<p>power-settings-deployment works!</p>
